<template>
    <b-card title="Control de registres">

        <!-- VERIFY BOOKINGS -->
        <b-row>
            <b-col cols="12">
                <b-overlay :show="loading" rounded="sm" variant="white" opacity="0.9">
                    <v-u-d-numbers-table :loading="loading" :items="vudNumbers" @vud-validated="fetchVUDNumbers" />
                </b-overlay>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BOverlay
} from "bootstrap-vue";
import VUDNumbersTable from "@/views/administration/vud-reports/components/VUDNumbersTable.vue";
import { notifyError } from "@/utils/methods";

export default {
    components: {
        BOverlay,
        BCard,
        BRow,
        BCol,
        VUDNumbersTable
    },
    data() {
        return {
            reportDatesRange: {
                from: null,
                to: null,
            },
            vudNumbers: [],
        };
    },
    computed: {
        loading() {
            return this.$store.getters["accommodations/loading"];
        },
    },
    mounted() {
        this.fetchVUDNumbers();
    },
    methods: {
        fetchVUDNumbers() {
            return this.$store
                .dispatch("accommodations/fetchAccommodationVUDNumbers")
                .then((response) => {
                    this.vudNumbers = response || [];
                })
                .catch(() => {
                    notifyError(
                        this.$t("errors.fetchVUDNumbers.title"),
                        this.$t("errors.fetchVUDNumbers.description")
                    );
                });
        }
    },
};
</script>
